// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_odp5-"};